<template>
  <section :class="['flex', { 'app-loading__overlay': fullScreen }]">
    <div
      :class="[
        'app-loading m-auto',
        {
          'app-loading--white': white,
          'app-loading--medium': medium,
        },
      ]"
    >
      <i 
        v-if="small" 
        class="loading loading-spinner loading-xs" 
        role="status" 
        aria-label="Loading content"
      >
        <span class="sr-only">{{ $t('Loading') }}...</span>
      </i>
      <div v-else class="app-loading__item" role="status" aria-live="polite">
        <span class="app-loading__item__inner">Loading...</span>
        <span class="sr-only">{{ $t('Content is loading') }}</span>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  fullScreen?: boolean
  small?: boolean
  white?: boolean
  medium?: boolean
}>()
</script>
